import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Link,
  Divider,
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#1a365d',
        color: 'white',
        py: 6,
        mt: 'auto',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          px: { xs: 2, md: 3 },
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {/* Header Section */}
        <Box sx={{ mb: 4, textAlign: 'center', width: '100%', maxWidth: '1200px' }}>
          <Box
            component="img"
            src="/images/LOGO Stempel.png"
            alt="DAD-Service Logo"
            sx={{
              width: 50,
              height: 50,
              mb: 2,
              filter: 'brightness(0) invert(1)',
            }}
          />
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            DAD-Service GbR
          </Typography>
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)', lineHeight: 1.6 }}>
            Ihr zuverlässiger Partner für Elektro- und Gebäudetechnik im Rhein-Main-Gebiet.
          </Typography>
        </Box>

        {/* Columns Section */}
        <Box sx={{ mb: 4, width: '100%', maxWidth: '1200px' }}>
          <Grid container spacing={{ xs: 3, md: 4 }} justifyContent="center">
            {/* Kontakt */}
            <Grid item xs={12} sm={6} md={6} lg={3} sx={{ textAlign: { xs: 'center', sm: 'center', md: 'left' } }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                Kontakt
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, alignItems: { xs: 'center', sm: 'center', md: 'flex-start' } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: 'center', sm: 'center', md: 'flex-start' } }}>
                  <PhoneIcon sx={{ mr: 1.5, fontSize: '1.1rem', display: { xs: 'none', md: 'block' }  }} />
                  <Link
                    href="tel:015906794985"
                    sx={{
                      color: 'white',
                      textDecoration: 'none',
                      fontSize: '0.95rem',
                      '&:hover': { textDecoration: 'underline' },
                    }}
                  >
                    0159 067 949 85
                  </Link>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: 'center', sm: 'center', md: 'flex-start' } }}>
                  <EmailIcon sx={{ mr: 1.5, fontSize: '1.1rem', display: { xs: 'none', md: 'block' } }} />
                  <Link
                    href="mailto:info@dad-service.de"
                    sx={{
                      color: 'white',
                      textDecoration: 'none',
                      fontSize: '0.95rem',
                      '&:hover': { textDecoration: 'underline' },
                    }}
                  >
                    info@dad-service.de
                  </Link>
                </Box>
              </Box>
            </Grid>

            {/* Hauptniederlassung */}
            <Grid item xs={12} sm={6} md={6} lg={3} sx={{ textAlign: { xs: 'center', sm: 'center', md: 'left' } }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                Hauptniederlassung
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, alignItems: { xs: 'center', sm: 'center', md: 'flex-start' } }}>
                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.9)', fontWeight: 600, fontSize: '0.95rem' }}>
                  DAD-Service GbR
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.95rem' }}>
                  Breslauerstraße 44
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.95rem' }}>
                  60598 Frankfurt
                </Typography>
              </Box>
            </Grid>

            {/* Zweigniederlassung */}
            <Grid item xs={12} sm={6} md={6} lg={3} sx={{ textAlign: { xs: 'center', sm: 'center', md: 'left' } }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                Zweigniederlassung
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, alignItems: { xs: 'center', sm: 'center', md: 'flex-start' } }}>
                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.9)', fontWeight: 600, fontSize: '0.95rem' }}>
                  DAD-Service GbR
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.95rem' }}>
                  Tauberstraße 54
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.95rem' }}>
                  63741 Aschaffenburg
                </Typography>
              </Box>
            </Grid>

            {/* Servicezeiten */}
            <Grid item xs={12} sm={6} md={6} lg={3} sx={{ textAlign: { xs: 'center', sm: 'center', md: 'left' } }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                Servicezeiten
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, alignItems: { xs: 'center', sm: 'center', md: 'flex-start' } }}>
                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.95rem' }}>
                  Mo – Fr 8:00 – 18:00 Uhr
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.95rem' }}>
                  Notdienst 24/7
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Divider sx={{ my: 3, borderColor: 'rgba(255, 255, 255, 0.2)', width: '100%', maxWidth: '1200px' }} />

        {/* Bottom Links */}
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          px: { xs: 2, md: 0 },
          width: '100%',
          maxWidth: '1200px'
        }}>
          <Box sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: { xs: 2, md: 3 },
            mb: 2,
            width: '100%'
          }}>
            <Link
              href="/rechtliches#impressum"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                textDecoration: 'none',
                fontSize: { xs: '0.85rem', md: '0.9rem' },
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Impressum
            </Link>
            <Link
              href="/rechtliches#datenschutz"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                textDecoration: 'none',
                fontSize: { xs: '0.85rem', md: '0.9rem' },
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Datenschutz
            </Link>
          </Box>
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.6)', fontSize: '0.9rem', textAlign: 'center' }}>
            © 2024 DAD-Service GbR. Alle Rechte vorbehalten.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;

